import ComponentPlaceholder from 'components/ComponentPlaceholder';
import Message from 'components/Message';
import Text from 'components/Text';
import { useIsEditing } from 'hooks';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';

interface Props extends SitecoreBlockProps {
	fields?: {
		heading: Field<string>;
	};
}

export default function HiddenHeading({ fields, params }: Props) {
	const isEditing = useIsEditing();

	if (!fields) {
		return null;
	}

	if (!fields.heading) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="HiddenHeading"
				description="Requires a heading"
			/>
		);
	}

	if (isEditing) {
		return (
			<>
				<Message
					variant="information"
					text="This heading is only visible in the experience editor"
				/>
				<Text as={params?.heading ?? 'h2'} field={fields.heading} />
			</>
		);
	}

	return (
		<Text
			as={params?.heading ?? 'h2'}
			field={fields.heading}
			// A heading feels important enough to show it if it gets focused.
			className="sr-only-focusable focus-within:p-r-md"
		/>
	);
}
HiddenHeading.displayName = 'HiddenHeading';
